import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { assetImg } from "@/modules/moduleImporter";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import { getATValue } from "@/modules/commonPopupResultHistory";
import { betGroupProp, getGongBallTotal } from "@/modules/commonMobile";

interface IProps extends Omit<IGameTableType, "win"> {
    win: IGongballWinType;
}

interface IGongballWinType {
    result: string;
    angka1: string;
    angka2: string;
}

export default class M16 extends React.Component<IProps> {
    state = { activeHover: "" };

    render() {
        const { langdata } = this.props;

        const win = this.props.win || null;
        //{angka: "9,Q,6", angka1: "7,1,5", angka2: "9,K,K", result: "Banker"};

        const kingComponent = (extraKey) => assetImg("gb_history", "K", "tp_0_" + extraKey); //<img key="tp_0" src={gb_history["K"]} alt="card_k" />;
        const threePicComponent = [
            kingComponent("threepic"),
            assetImg("gb_history", "Q", "tp_1"),
            assetImg("gb_history", "J", "tp_2")
            // <img key="tp_1" src={gb_history["Q"]} alt="card_q" />,
            // <img key="tp_2" src={gb_history["J"]} alt="card_j" />
        ];


        //filled from Lobby
        const { gongBallResult } = this.props.data;
        //{banker: "", player: ""};
        //{banker: "1,2,3", player: "4,5,6"};

        const totalResult = getGongBallTotal(gongBallResult);
        // {
        //     banker: gongBallResult ? gongBallResult.banker.split(",").map(card => getATValue(card)).reduce((a, b) => a + b, 0) % 10 : 0,
        //     player: gongBallResult ? gongBallResult.player.split(",").map(card => getATValue(card)).reduce((a, b) => a + b, 0) % 10 : 0
        // };


        console.debug(gongBallResult);

        let totalWin = null;
        let totalWinLetters = null;

        //{angka: "9,Q,6", angka1: "7,1,5", angka2: "9,Q,6", result: "Player"}

        if (win && win.result) {
            if (win.result === "Banker") {
                totalWin = win.angka1.split(",")
                    .map(item => getATValue(item)).reduce((a, b) => a + b) % 10;

                totalWinLetters = {
                    "J": (win.angka1.match(/J/g) || []).length,
                    "Q": (win.angka1.match(/Q/g) || []).length,
                    "K": (win.angka1.match(/K/g) || []).length,
                    "all": (win.angka1.match(/J|Q|K/g) || []).length
                };
            } else { //Player or Draw
                totalWin = win.angka2.split(",")
                    .map(item => getATValue(item)).reduce((a, b) => a + b) % 10;

                totalWinLetters = {
                    "J": (win.angka2.match(/J/g) || []).length,
                    "Q": (win.angka2.match(/Q/g) || []).length,
                    "K": (win.angka2.match(/K/g) || []).length,
                    "all": (win.angka2.match(/J|Q|K/g) || []).length
                };
            }
        }

        
        const virtualResult = <>
            <div className="m16-player-wrapper">
                <div className="sl-pl-bk">
                    {this.props.langdata["txt_player"]}
                </div>

                <div>
                    {
                        gongBallResult && gongBallResult.player ?
                            gongBallResult.player.split(",").map((item, idx) => {
                                // totalResult.player = (totalResult.player + getATValue(item)) % 10;
                                return assetImg("gb_history", item, "player_win_" + idx);
                            }) : null
                    }
                </div>
            </div>
            <div className="m16-player-wrapper">
                <div className="sl-pl-bk">{this.props.langdata["txt_banker"]}</div>
                <div className="">
                    {
                        gongBallResult && gongBallResult.banker ?
                            gongBallResult.banker.split(",").map((item, idx) => {
                                // totalResult.banker = (totalResult.banker + getATValue(item)) % 10;
                                return assetImg("gb_history", item, "banker_win_" + idx);
                            }) : null
                    }
                </div>
            </div>
        </>;



        const commonChipProps = {
            mobile: this.props.mobile,
            chipBase: this.props.chipBase,
            bets: this.props.bets,
            betOutOfBounds: this.props.betOutOfBounds
        };

        const commonTooltipProps = {
            langStr: langdata.language_code
        };


        return (
            this.props.portrait ?
                <div className="sl-table m16-portrait">
                    <div className="row">
                        <div className={"sl-bet sl-gongball-blue col-xs-6 sl-green-old" + (win && (win.result === "Player") ? " sl-yellow-alternating" : "")}
                            {...betGroupProp(this, "Player", "player")}
                            // bet="Player" pcode={this.props.pcode} group="player"
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_bet"]} {this.props.langdata["txt_player"]}
                            <div className="bet-type">1:0.97</div>
                            <Chips {...commonChipProps} betKey="Player+player" />
                        </div>
                        <div className={"sl-bet sl-gongball-red col-xs-6 sl-green-old" + (win && (win.result === "Banker") ? " sl-yellow-alternating" : "")}
                            // bet="Banker" pcode={this.props.pcode} group="player"
                            {...betGroupProp(this, "Banker", "player")}
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_bet"]} {this.props.langdata["txt_banker"]}
                            <div className="bet-type">1:0.97</div>
                            <Chips {...commonChipProps} betKey="Banker+player" />
                        </div>
                    </div>

                    <div className="row">
                        <div className={"sl-bet sl-green-old col-xs-6 sl-green-old" + (win && totalWin < 5 && win.result ? " sl-yellow-alternating" : "")}
                            // bet="small" pcode={this.props.pcode} group="n50"
                            {...betGroupProp(this, "small", "n50")}
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_small"]}
                            <div className="bet-type">1:0.95</div>
                            <Chips {...commonChipProps} betKey="small+n50" />
                        </div>
                        <div className={"sl-bet sl-green-old col-xs-6 sl-green-old" + (win && totalWin >= 5 ? " sl-yellow-alternating" : "")}
                            // bet="big" pcode={this.props.pcode} group="n50"
                            {...betGroupProp(this, "big", "n50")}
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_big"]}
                            <div className="bet-type">1:0.95</div>
                            <Chips {...commonChipProps} betKey="big+n50" />
                        </div>
                    </div>

                    <div className="row">
                        <div className={"sl-bet sl-green-old col-xs-6 sl-green-old" + (win && (totalWin % 2) ? " sl-yellow-alternating" : "")}
                            //bet="odd" pcode={this.props.pcode} group="n50"
                            {...betGroupProp(this, "odd", "n50")}
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_odd"]}
                            <div className="bet-type">1:0.95</div>
                            <Chips {...commonChipProps} betKey="odd+n50" />
                        </div>
                        <div className={"sl-bet sl-green-old col-xs-6 sl-green-old" + (win && !(totalWin % 2) && win.result ? " sl-yellow-alternating" : "")}
                            // bet="even" pcode={this.props.pcode} group="n50"
                            {...betGroupProp(this, "even", "n50")}
                            onClick={this.props.insertBet}>
                            {this.props.langdata["txt_even"]}
                            <div className="bet-type">1:0.95</div>
                            <Chips {...commonChipProps} betKey="even+n50" />
                        </div>
                    </div>

                    <div className="row">
                        {
                            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(num =>
                                <div key={"m16_portrait_" + num + "+n"}
                                    className={"sl-bet sl-green-old cards taller col-20p sl-green-old" + (win && totalWin === num ? " sl-yellow-alternating" : "")}
                                    // bet={num} pcode={this.props.pcode} group="n"
                                    {...betGroupProp(this, num + "", "n")}

                                    onClick={this.props.insertBet}>

                                    { /* <img src={gb_cards[num]} alt={"card_" + num} /> */}
                                    {assetImg("gb_cards", num + "", "m16_cards_" + num)}

                                    <div className="bet-type">1:8.5</div>
                                    <Chips {...commonChipProps} betKey={num + "+n"} />
                                </div>
                            )
                        }
                    </div>

                    <div className="row">
                        <div className={
                            "sl-bet disabled sl-green-old taller col-xs-12 sl-green-old" +
                            (totalWinLetters && totalWinLetters.all === 3 ? " sl-yellow-alternating" : "")
                        }
                            //bet="3pic" pcode={this.props.pcode} group="pic3"
                            {...betGroupProp(this, "3pic", "pic3")}
                            onClick={this.props.insertBet}
                        >

                            <div>3 {this.props.langdata["txt_pictures"]}</div>
                            {threePicComponent}
                            <div className="bet-type">1:330</div>
                            <Chips {...commonChipProps} betKey="3pic+pic3" />
                        </div>
                    </div>

                    <div className="row">
                        <div className={
                            "sl-bet disabled sl-green-old taller col-xs-6 sl-green-old" +
                            (totalWinLetters && totalWinLetters.K === 2 ? " sl-yellow-alternating" : "")
                        }
                            //bet="2K" pcode={this.props.pcode} group="k2"
                            {...betGroupProp(this, "2K", "k2")}
                            onClick={this.props.insertBet}
                        >

                            <div>KK</div>
                            {kingComponent("p_2K_1")}
                            {kingComponent("p_2K_2")}
                            <div className="bet-type">1:200</div>
                            <Chips {...commonChipProps} betKey="2K+k2" />
                        </div>

                        <div className={"sl-bet sl-green-old taller col-xs-6 sl-green-old" + (totalWinLetters && totalWinLetters.K === 1 ? " sl-yellow-alternating" : "")}
                            // bet="K" pcode={this.props.pcode} group="k1"
                            {...betGroupProp(this, "K", "k1")}
                            onClick={this.props.insertBet}>
                            <div>K</div>
                            {kingComponent("p_K")}
                            <div className="bet-type">1:5</div>
                            <Chips {...commonChipProps} betKey="K+k1" />
                        </div>
                    </div>
                </div>


                : <div className="sl-table m16-table">
                    <div className="m16-top">
                        <div className={"sl-bet sl-gongball-blue m16-top-large-left" + (win && (win.result === "Player") ? " sl-yellow-alternating" : "")}
                            // bet="Player" pcode={this.props.pcode} group="player"
                            {...betGroupProp(this, "Player", "player")}
                            onClick={this.props.insertBet}>

                            <div className="m16-top-text">
                                {this.props.langdata["txt_bet"]} {this.props.langdata["txt_player"]}
                            </div>

                            <div className="bet-type">1:0,97</div>
                            <Chips {...commonChipProps} betKey="Player+player" />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets["Player+player"]} />
                        </div>

                        {virtualResult}

                        <div className={"sl-bet sl-gongball-red m16-top-large-right" + (win && (win.result === "Banker") ? " sl-yellow-alternating" : "")}
                            // bet="Banker" pcode={this.props.pcode} group="player"
                            {...betGroupProp(this, "Banker", "player")}
                            onClick={this.props.insertBet}>
                            <div className="m16-top-text">
                                {this.props.langdata["txt_bet"]} {this.props.langdata["txt_banker"]}
                            </div>
                            <div className="bet-type">1:0,97</div>
                            <Chips {...commonChipProps} betKey="Banker+player" />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets["Banker+player"]} />
                        </div>
                    </div>
                    <div className="m16-middle">
                        <div>
                            <div className={"sl-bet sl-green-old" + (win && totalWin < 5 && win.result ? " sl-yellow-alternating" : "")}
                                // bet="small" pcode={this.props.pcode} group="n50"
                                {...betGroupProp(this, "small", "n50")}
                                onClick={this.props.insertBet}
                                onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}>
                                <div className="m16-middle-text">{this.props.langdata["txt_small"]}</div>
                                <div className="bet-type">1:0,95</div>
                                <Chips {...commonChipProps} betKey={"small+n50"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["small+n50"]} />
                            </div>
                            <div className={"sl-bet sl-green-old" + (totalWin >= 5 ? " sl-yellow-alternating" : "")}
                                // bet="big" pcode={this.props.pcode} group="n50"
                                {...betGroupProp(this, "big", "n50")}
                                onClick={this.props.insertBet}
                                onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}>
                                <div className="m16-middle-text">{this.props.langdata["txt_big"]}</div>
                                <div className="bet-type">1:0,95</div>
                                <Chips {...commonChipProps} betKey={"big+n50"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["big+n50"]} />
                            </div>
                        </div>
                        {
                            [0, 1, 2, 3, 4].map(num => {
                                let styles = "";
                                const activeHover = this.state.activeHover;

                                if ((activeHover === "odd" && ((num) % 2)) ||
                                    (activeHover === "even" && !((num) % 2)) ||
                                    (activeHover === "small" && num < 5) ||
                                    (activeHover === "big" && num >= 5))
                                    styles += " sl-bet-hover";
                                if (totalWin === num)
                                    styles += " sl-yellow-alternating";

                                return (
                                    <div key={"gb_" + num} className={"sl-bet sl-green-old" + styles}
                                        // bet={num} pcode={this.props.pcode} group="n"
                                        {...betGroupProp(this, num + "", "n")}
                                        onClick={this.props.insertBet}>

                                        { assetImg("gb_cards", num + "")}
                                        <div className="bet-type">1:8,5</div>
                                        <Chips {...commonChipProps} betKey={num + "+n"} />
                                        <Tooltip {...commonTooltipProps} bet={this.props.bets[num + "+n"]} />
                                    </div>
                                );
                            })
                        }
                        <div className={
                            "sl-bet sl-green-old" +
                            (totalWinLetters && totalWinLetters.all === 3 ? " sl-yellow-alternating" : "")}
                            // bet="3pic" pcode={this.props.pcode} group="pic3"
                            {...betGroupProp(this, "3pic", "pic3")}
                            onClick={this.props.insertBet}
                        >
                            <div className="m16-card-group">
                                {threePicComponent}
                                <div>3 {this.props.langdata["txt_pictures"]}</div>
                                <div className="bet-type">1:330</div>
                                <Chips {...commonChipProps} betKey="3pic+pic3" />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["3pic+pic3"]} />
                            </div>
                        </div>
                    </div>
                    {/*second line*/}
                    <div className="m16-bottom">
                        <div>
                            <div className={"sl-bet sl-green-old" + (win && !(totalWin % 2) && win.result ? " sl-yellow-alternating" : "")}
                                // bet="even" pcode={this.props.pcode} group="n50"
                                {...betGroupProp(this, "even", "n50")}
                                onClick={this.props.insertBet}
                                onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}>
                                <div className="m16-middle-text">{this.props.langdata["txt_even"]}</div>
                                <div className="bet-type">1:0,95</div>
                                <Chips {...commonChipProps} betKey={"even+n50"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["even+n50"]} />
                            </div>
                            <div className={"sl-bet sl-green-old" + ((totalWin % 2) ? " sl-yellow-alternating" : "")}
                                // bet="odd" pcode={this.props.pcode} group="n50"
                                {...betGroupProp(this, "odd", "n50")}
                                onClick={this.props.insertBet}
                                onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}>
                                <div className="m16-middle-text">{this.props.langdata["txt_odd"]}</div>
                                <div className="bet-type">1:0,95</div>
                                <Chips {...commonChipProps} betKey={"odd+n50"} />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["odd+n50"]} />
                            </div>
                        </div>
                        {
                            [5, 6, 7, 8, 9].map(num => {
                                let styles = "";
                                const activeHover = this.state.activeHover;

                                if ((activeHover === "odd" && ((num) % 2)) ||
                                    (activeHover === "even" && !((num) % 2)) ||
                                    (activeHover === "small" && num < 5) ||
                                    (activeHover === "big" && num >= 5))
                                    styles += " sl-bet-hover";
                                if (totalWin === num)
                                    styles += " sl-yellow-alternating";

                                return (
                                    <div key={"gb_" + num} className={"sl-bet sl-green-old" + styles}
                                        // bet={num} pcode={this.props.pcode} group="n"
                                        {...betGroupProp(this, num + "", "n")}
                                        onClick={this.props.insertBet}>
                                        { assetImg("gb_cards", num + "")}
                                        <div className="bet-type">1:8,5</div>
                                        <Chips {...commonChipProps} betKey={num + "+n"} />
                                        <Tooltip {...commonTooltipProps} bet={this.props.bets[num + "+n"]} />
                                    </div>);
                            })
                        }
                        <div className={"sl-bet sl-green-old" + (totalWinLetters && totalWinLetters.K === 2 ? " sl-yellow-alternating" : "")}
                            // bet="2K" pcode={this.props.pcode} group="k2"
                            {...betGroupProp(this, "2K", "k2")}
                            onClick={this.props.insertBet}
                        >

                            <div className="m16-card-group">
                                {kingComponent("2K_1")}
                                {kingComponent("2K_2")}
                                <div></div>
                                <div>KK</div>
                                <div className="bet-type">1:200</div>
                                <Chips {...commonChipProps} betKey="2K+k2" />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["2K+k2"]} />
                            </div>
                        </div>
                        <div className={"sl-bet sl-green-old" + (totalWinLetters && totalWinLetters.K === 1 ? " sl-yellow-alternating" : "")}
                            // bet="K" pcode={this.props.pcode} group="k1"
                            {...betGroupProp(this, "K", "k1")}
                            onClick={this.props.insertBet}>
                            <div className="m16-card-group">
                                {kingComponent("K")}
                                <div></div>
                                <div></div>
                                <div>K</div>
                                <div className="bet-type">1:5</div>
                                <Chips {...commonChipProps} betKey="K+k1" />
                                <Tooltip {...commonTooltipProps} bet={this.props.bets["K+k1"]} />
                            </div>
                        </div>
                    </div>
                    {
                        //Shows banker & player score overlay
                        gongBallResult &&
                        <div className="overlay-gongball">
                            <div className="result-player-label">
                                {langdata["txt_player"]}
                            </div>
                            <div className="result-player">{totalResult.player}</div>

                            <div className="result-banker-label">
                                {langdata["txt_banker"]}
                            </div>
                            <div className="result-banker">{totalResult.banker}</div>
                        </div>
                    }

                </div>
        );
    }
}
